/**
 * Copy text to clipboard by appending input element
 * @param {String} text text to copy
 * @returns {Boolean} Success status
 */
export const copyTextToClipboardFallback = (text) => {
  const hiddenInput = document.createElement("textarea");
  // browser compatibility
  hiddenInput.textContent = text;
  hiddenInput.value = text;

  // display none or visibility hidden will not work ¯\_(ツ)_/¯
  hiddenInput.style.position = "absolute";
  hiddenInput.style.left = "-9999px";

  document.body.appendChild(hiddenInput);

  const selection = document.getSelection();
  const range = document.createRange();

  range.selectNode(hiddenInput);
  selection.removeAllRanges();
  selection.addRange(range);

  const success = document.execCommand("copy");

  document.body.removeChild(hiddenInput);
  selection.removeAllRanges();

  return success;
};

/**
 * Copy text to clipboard
 * @param {String} text text to copy
 * @returns {Boolean} Success status
 */
export const copyTextToClipboard = async (text) => {
  text = String(text || "");

  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    //
  }

  return copyTextToClipboardFallback(text);
};
